export const consoleMsgFinally = (action, message) => {
    if (process.env.NODE_ENV == 'development') {
        console.log(`[${action}] ${message}`)
    }
}
